/* unplugin-vue-components disabled */import script from "./EventInfoPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EventInfoPopup.vue?vue&type=script&setup=true&lang=js"

import "./EventInfoPopup.vue?vue&type=style&index=0&id=0bb73f0c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb73f0c"]])

export default __exports__